import { Typography } from 'antd'
import { useMatch } from 'react-router'
import { routes } from 'app/routes'

const PageTitle = () => {
  const editMatch = useMatch(routes.invoices.patterns.edit)
  const newMatch = useMatch(routes.invoices.new)
  const showMatch = useMatch(routes.invoices.patterns.show)
  const listMatch = useMatch(routes.invoices.list)

  const title =
    (editMatch && 'Edit Invoice') ||
    (newMatch && 'New Invoice') ||
    (showMatch && 'Invoice details') ||
    (listMatch && 'Invoices list') ||
    null

  if (!title) return null
  return (
    <Typography.Title level={2} className="mb-3">
      {title}
    </Typography.Title>
  )
}

export default PageTitle
